'use client';

import utilsStyles from '@/styles/modules/utils.module.scss';
import { diffDateTimeHours, newDate } from '@/utils/date';
import { formatCurrency } from '@monorepo/common';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { type EcItemDetailType, EcItemSaleStatus } from '../../types';
import { ecItemStatusColor } from '../../utils';
import EcItemPurchaseButton from '../EcItemPurchaseButton/EcItemPurchaseButton';
import styles from './EcItemFab.module.scss';

function EcItemFab({
  ecItem,
  isPreview,
}: {
  ecItem: EcItemDetailType;
  isPreview?: boolean;
}) {
  const [timeLeft, setTimeLeft] = useState('');
  const router = useRouter();
  useEffect(() => {
    if (ecItem.status === EcItemSaleStatus.later.value || ecItem.currentStock === 0) return;

    const diffTargetDate =
      ecItem.status === EcItemSaleStatus.upcoming.value ? newDate(ecItem.saleStartAt) : newDate(ecItem.saleEndAt);
    const interval = window.setInterval(() => {
      const currentDate = newDate();
      const diff = diffDateTimeHours(diffTargetDate, currentDate);
      setTimeLeft(`${diff.days}日${diff.hours}時間${diff.minutes}分${diff.seconds}秒`);
    }, 1000);

    // プレビューの場合は全てのクリックイベント無効
    if (isPreview) {
      window.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        true,
      );
    }

    return () => {
      window.clearInterval(interval);
    };
  }, [ecItem]);

  const goPurchaseConfirm = async () => {
    router.push(`/e-commerce/digital-contents/purchase/${ecItem.productId}`);
  };

  return (
    <div className={styles.componentStyle}>
      <div className={styles.leftContainer}>
        <p className={`${utilsStyles.textXLarge} ${utilsStyles.textBold}`}>
          ¥{formatCurrency(ecItem.taxIncludedPrice)}
        </p>
        {timeLeft ? (
          <p className={utilsStyles.textXSmall}>
            {ecItem.status === EcItemSaleStatus.upcoming.value ? '開始' : '終了'}まで{timeLeft}
          </p>
        ) : (
          <></>
        )}
      </div>
      {submitButton(ecItem, goPurchaseConfirm)}
    </div>
  );
}

function submitButton(ecItem: EcItemDetailType, goPurchaseConfirm: () => void) {
  switch (ecItem.status) {
    case EcItemSaleStatus.on_sale.value:
      return (
        <EcItemPurchaseButton bgColor={ecItemStatusColor(ecItem.status)} onClick={goPurchaseConfirm}>
          購入する
        </EcItemPurchaseButton>
      );
    case EcItemSaleStatus.upcoming.value:
      return (
        // 販売予定だけはUIの都合上ラベルと異なる色
        <EcItemPurchaseButton bgColor='black' disabled outlined>
          販売予定
        </EcItemPurchaseButton>
      );
    case EcItemSaleStatus.later.value:
      return (
        <EcItemPurchaseButton bgColor={ecItemStatusColor(ecItem.status)} disabled>
          販売終了
        </EcItemPurchaseButton>
      );
    case EcItemSaleStatus.sold.value:
      return (
        <EcItemPurchaseButton bgColor={ecItemStatusColor(ecItem.status)} disabled>
          完売
        </EcItemPurchaseButton>
      );
    default:
      return <></>;
  }
}

export default EcItemFab;
